export type ToastTone = 'error' | 'success' | 'info';

export interface Toast {
  id: string;
  tone: ToastTone;
  message: string;
}

const MAX_TOASTS = 4;

let toasts: Toast[] = [];
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function subscribeToasts(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Stable array reference until the store mutates (required for useSyncExternalStore). */
export function getToasts(): Toast[] {
  return toasts;
}

export function pushToast(message: string, tone: ToastTone = 'info'): string {
  const trimmed = message.trim() || 'Something went wrong.';
  const id =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const next = [...toasts, { id, message: trimmed, tone }];
  toasts = next.length > MAX_TOASTS ? next.slice(next.length - MAX_TOASTS) : next;
  emit();
  return id;
}

export function dismissToast(id: string) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}
